import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { request, gql } from 'graphql-request'
import { SUBGRAPH_DEPLOYMENT_IDS } from '../constants/networks'

interface SubgraphStatus {
  subgraph: string
  synced: boolean
  fatalError?: {
    message: string
  }
  nonFatalErrors?: {
    message: string
  }[]
  chainId: string
}

const useSubgraphs = (): UseQueryResult<SubgraphStatus[]> => {
  return useQuery<SubgraphStatus[]>({
    queryKey: ['useSubgraphs'],
    queryFn: () => fetchAllTasks(),
  })
}

const fetchSubgraph = async (chainId: number): Promise<SubgraphStatus | null> => {
  try {
    const data = await request<{ indexingStatuses: SubgraphStatus[] }>(
      'https://api.thegraph.com/index-node/graphql',
      gql`
        query Subgraphs($subgraphs: [String!]!) {
          indexingStatuses(subgraphs: $subgraphs) {
            subgraph
            synced
            health
            node
            fatalError {
              message
            }
            nonFatalErrors {
              message
            }
          }
        }
      `,
      { subgraphs: [SUBGRAPH_DEPLOYMENT_IDS[chainId]] }
    )
    return data.indexingStatuses.length > 0 ? { ...data.indexingStatuses[0], chainId: chainId.toString() } : null

  } catch (error) {
    console.error(`Error fetching subgraph for chain ${chainId}:`, error)
    return null
  }
}


const fetchAllTasks = async (): Promise<SubgraphStatus[]> => {
  const chainIds = Object.keys(SUBGRAPH_DEPLOYMENT_IDS).map(Number)

  const results = await Promise.all(chainIds.map(fetchSubgraph))

  return results.filter((result): result is SubgraphStatus => result !== null)
}

export default useSubgraphs
